import React from 'react';
import { connect } from 'react-redux';
import { isInitial, isEco, isRebrand } from 'helpers/RequestHelper';

const RequestPageHeader = ({ request }) => {
  const renderId = tn => {
    if (tn) return `${tn}`;
    return '';
  };

  const renderTitle = type => {
    if (isInitial(type)) return 'Initial';
    if (isEco(type)) return 'ECO';
    if (isRebrand(type)) return 'Rebrand';
    return 'Uncategorized';
  };

  const { type, tn } = request;
  const reqId = renderId(tn);
  const pageHeader = renderTitle(type);

  return (
    <h1>
      {pageHeader} Certification Request {reqId}
    </h1>
  );
};

function mapStateToProps({ request }) {
  return { request };
}

export default connect(mapStateToProps)(RequestPageHeader);



// WEBPACK FOOTER //
// ./src/components/request/RequestPageHeader.js